interface LocationMenusButtonProps {
  /** Number of menus the location has; null when unknown (an API that doesn't report it yet). */
  menuCount: number | null;
  onAddMenu: () => void;
  onEditMenus: () => void;
}

const BUTTON_CLASS =
  "px-4 py-1.5 rounded-full text-xs text-white transition-colors whitespace-nowrap";

/**
 * ADD MENUS for a location with no menus, EDIT MENUS for one that has some (TAB-575). Used by the
 * Locations list (Brand Profile) and Location Profile. With an unknown count it shows both, as the
 * Locations list did before the API reported menu counts.
 */
const LocationMenusButton = ({
  menuCount,
  onAddMenu,
  onEditMenus,
}: LocationMenusButtonProps) => {
  const showAdd = menuCount === null || menuCount === 0;
  const showEdit = menuCount === null || menuCount > 0;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {showAdd && (
        <button
          type="button"
          className={BUTTON_CLASS}
          style={{
            backgroundColor: "var(--color-accent)",
            width: "fit-content",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "var(--color-accent-hover)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "var(--color-accent)";
          }}
          onClick={onAddMenu}
        >
          ADD MENUS
        </button>
      )}
      {showEdit && (
        <button
          type="button"
          className={BUTTON_CLASS}
          style={{
            backgroundColor: "var(--color-primary-blue)",
            width: "fit-content",
          }}
          onClick={onEditMenus}
        >
          EDIT MENUS
        </button>
      )}
    </div>
  );
};

export default LocationMenusButton;
